import React, { useState } from 'react';
import { doc, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import './BookDetailModal.css';

function BookDetailModal({ book, onClose, onBookUpdate }) {
  console.log('BookDetailModal rendered for book:', book.title);
  const currentStatus = book.readingStatus || book.status;
  const [status, setStatus] = useState(currentStatus);
  const [rating, setRating] = useState(book.rating || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpdateStatus = async (newStatus) => {
    try {
      setLoading(true);
      await updateDoc(doc(db, 'books', book.id), {
        readingStatus: newStatus,
        updatedAt: new Date()
      });
      setStatus(newStatus);
      onBookUpdate();
    } catch (error) {
      console.error('Error updating book status:', error);
      setError('Failed to update status');
    }
    setLoading(false);
  };

  const handleUpdateRating = async () => {
    try {
      setLoading(true);
      const ratingValue = rating ? parseFloat(rating) : null;
      await updateDoc(doc(db, 'books', book.id), {
        rating: ratingValue,
        updatedAt: new Date()
      });
      onBookUpdate();
    } catch (error) {
      console.error('Error updating rating:', error);
      setError('Failed to update rating');
    }
    setLoading(false);
  };

  const handleDeleteBook = async () => {
    if (window.confirm('Are you sure you want to delete this book?')) {
      try {
        setLoading(true);
        await deleteDoc(doc(db, 'books', book.id));
        onBookUpdate();
        onClose();
      } catch (error) {
        console.error('Error deleting book:', error);
        setError('Failed to delete book');
      }
      setLoading(false);
    }
  };

  const getStatusClass = (statusValue) => {
    switch (statusValue) {
      case 'reading': return 'status-reading';
      case 'finished': return 'status-finished';
      case 'toRead': return 'status-to-read';
      case 'to-read': return 'status-to-read';
      default: return 'status-to-read';
    }
  };

  return (
    <div className="modal-overlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="modal-content book-detail-modal card">
        <div className="modal-header">
          <h2>Book Details</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="book-detail-content">
          <div className="book-detail-cover">
            {(book.imageUrl || book.thumbnail) ? (
              <img src={book.imageUrl || book.thumbnail} alt={`${book.title} cover`} />
            ) : (
              <div className="book-cover-placeholder">
                <div className="book-spine"></div>
                <div className="book-title">{book.title}</div>
              </div>
            )}
          </div>

          <div className="book-detail-info">
            <h3>{book.title}</h3>
            <p className="book-author">
              by {book.authors?.join(', ') || book.author || 'Unknown Author'}
            </p>

            {error && <div className="error-message">{error}</div>}

            <div className="status-section">
              <h4>Reading Status</h4>
              <div className="status-buttons">
                {['toRead', 'reading', 'finished'].map(statusOption => (
                  <button
                    key={statusOption}
                    className={`status-btn ${getStatusClass(statusOption)} ${status === statusOption ? 'active' : ''}`}
                    onClick={() => handleUpdateStatus(statusOption)}
                    disabled={loading}
                  >
                    {statusOption === 'toRead' ? 'To Read' : 
                     statusOption === 'reading' ? 'Reading' : 'Finished'}
                  </button>
                ))}
              </div>
            </div>

            <div className="rating-section">
              <h4>Rating (1-5)</h4>
              <div className="rating-input">
                <input
                  type="number"
                  min="1"
                  max="5"
                  step="0.1"
                  value={rating}
                  onChange={(e) => setRating(e.target.value)}
                  placeholder="Rate this book"
                />
                <button 
                  className="btn btn-secondary btn-sm"
                  onClick={handleUpdateRating}
                  disabled={loading}
                >
                  Update Rating
                </button>
              </div>
            </div>

            <div className="book-actions">
              <button 
                className="btn btn-error"
                onClick={handleDeleteBook}
                disabled={loading}
              >
                Delete Book
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookDetailModal;